import React from "react";
import { useSelector } from "react-redux";
import { selectAllSPatterns } from "../../../../redux/slices/selectedPatterns";
import { Container } from "./SelectedPatternsStyles";
import GridChart from "../../DetectionPreviewGrid/GridChart/GridChart";

export default function SelectedPatterns() {
  const selectedPatterns = useSelector(selectAllSPatterns);

  return (
    <Container>
      {selectedPatterns.length &&
        selectedPatterns.map((pattern, index) => (
          <GridChart
            toolbar
            training={false}
            key={pattern.id}
            pattern={pattern}
            type="detected"
            height={100}
            width={130}
            onClick={() => {}}
          />
        ))}
    </Container>
  );
}
